/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BookingDto } from '../models/booking-dto';
import { closeBox } from '../fn/user-bookings-api/close-box';
import { CloseBox$Params } from '../fn/user-bookings-api/close-box';
import { createBooking } from '../fn/user-bookings-api/create-booking';
import { CreateBooking$Params } from '../fn/user-bookings-api/create-booking';
import { createShare } from '../fn/user-bookings-api/create-share';
import { CreateShare$Params } from '../fn/user-bookings-api/create-share';
import { deleteShare } from '../fn/user-bookings-api/delete-share';
import { DeleteShare$Params } from '../fn/user-bookings-api/delete-share';
import { getAmount } from '../fn/user-bookings-api/get-amount';
import { GetAmount$Params } from '../fn/user-bookings-api/get-amount';
import { getBookingLogs } from '../fn/user-bookings-api/get-booking-logs';
import { GetBookingLogs$Params } from '../fn/user-bookings-api/get-booking-logs';
import { getBookingOpenCount } from '../fn/user-bookings-api/get-booking-open-count';
import { GetBookingOpenCount$Params } from '../fn/user-bookings-api/get-booking-open-count';
import { getBookingReadyToTerminate } from '../fn/user-bookings-api/get-booking-ready-to-terminate';
import { GetBookingReadyToTerminate$Params } from '../fn/user-bookings-api/get-booking-ready-to-terminate';
import { getBookingShareById } from '../fn/user-bookings-api/get-booking-share-by-id';
import { GetBookingShareById$Params } from '../fn/user-bookings-api/get-booking-share-by-id';
import { getBookingShares } from '../fn/user-bookings-api/get-booking-shares';
import { GetBookingShares$Params } from '../fn/user-bookings-api/get-booking-shares';
import { getBookingTowerInfo } from '../fn/user-bookings-api/get-booking-tower-info';
import { GetBookingTowerInfo$Params } from '../fn/user-bookings-api/get-booking-tower-info';
import { getUserActiveBookings } from '../fn/user-bookings-api/get-user-active-bookings';
import { GetUserActiveBookings$Params } from '../fn/user-bookings-api/get-user-active-bookings';
import { getUserActiveBookings1 } from '../fn/user-bookings-api/get-user-active-bookings-1';
import { GetUserActiveBookings1$Params } from '../fn/user-bookings-api/get-user-active-bookings-1';
import { getUserOpenTowers } from '../fn/user-bookings-api/get-user-open-towers';
import { GetUserOpenTowers$Params } from '../fn/user-bookings-api/get-user-open-towers';
import { getUserTerminatedBookings } from '../fn/user-bookings-api/get-user-terminated-bookings';
import { GetUserTerminatedBookings$Params } from '../fn/user-bookings-api/get-user-terminated-bookings';
import { openBox } from '../fn/user-bookings-api/open-box';
import { OpenBox$Params } from '../fn/user-bookings-api/open-box';
import { PageDtoBookingBookingDto } from '../models/page-dto-booking-booking-dto';
import { PageDtoBookingLogBookingLogDto } from '../models/page-dto-booking-log-booking-log-dto';
import { PaymentAmountDto } from '../models/payment-amount-dto';
import { ShareDto } from '../models/share-dto';
import { SimpleBooleanValue } from '../models/simple-boolean-value';
import { SimpleNumValue } from '../models/simple-num-value';
import { terminateBooking } from '../fn/user-bookings-api/terminate-booking';
import { TerminateBooking$Params } from '../fn/user-bookings-api/terminate-booking';
import { TowerSimpleDto } from '../models/tower-simple-dto';
import { updateBookingPin } from '../fn/user-bookings-api/update-booking-pin';
import { UpdateBookingPin$Params } from '../fn/user-bookings-api/update-booking-pin';
import { updateShare } from '../fn/user-bookings-api/update-share';
import { UpdateShare$Params } from '../fn/user-bookings-api/update-share';

@Injectable({ providedIn: 'root' })
export class UserBookingsApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getBookingShareById()` */
  static readonly GetBookingShareByIdPath = '/api/user/bookings/{id}/shares/{shareId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBookingShareById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBookingShareById$Response(params: GetBookingShareById$Params, context?: HttpContext): Observable<StrictHttpResponse<ShareDto>> {
    return getBookingShareById(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBookingShareById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBookingShareById(params: GetBookingShareById$Params, context?: HttpContext): Observable<ShareDto> {
    return this.getBookingShareById$Response(params, context).pipe(
      map((r: StrictHttpResponse<ShareDto>): ShareDto => r.body)
    );
  }

  /** Path part for operation `updateShare()` */
  static readonly UpdateSharePath = '/api/user/bookings/{id}/shares/{shareId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateShare()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateShare$Response(params: UpdateShare$Params, context?: HttpContext): Observable<StrictHttpResponse<ShareDto>> {
    return updateShare(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateShare$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateShare(params: UpdateShare$Params, context?: HttpContext): Observable<ShareDto> {
    return this.updateShare$Response(params, context).pipe(
      map((r: StrictHttpResponse<ShareDto>): ShareDto => r.body)
    );
  }

  /** Path part for operation `deleteShare()` */
  static readonly DeleteSharePath = '/api/user/bookings/{id}/shares/{shareId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteShare()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteShare$Response(params: DeleteShare$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteShare(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteShare$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteShare(params: DeleteShare$Params, context?: HttpContext): Observable<void> {
    return this.deleteShare$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateBookingPin()` */
  static readonly UpdateBookingPinPath = '/api/user/bookings/{bookingId}/updatePin';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateBookingPin()` instead.
   *
   * This method doesn't expect any request body.
   */
  updateBookingPin$Response(params: UpdateBookingPin$Params, context?: HttpContext): Observable<StrictHttpResponse<BookingDto>> {
    return updateBookingPin(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateBookingPin$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  updateBookingPin(params: UpdateBookingPin$Params, context?: HttpContext): Observable<BookingDto> {
    return this.updateBookingPin$Response(params, context).pipe(
      map((r: StrictHttpResponse<BookingDto>): BookingDto => r.body)
    );
  }

  /** Path part for operation `terminateBooking()` */
  static readonly TerminateBookingPath = '/api/user/bookings/{bookingId}/terminate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `terminateBooking()` instead.
   *
   * This method doesn't expect any request body.
   */
  terminateBooking$Response(params: TerminateBooking$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return terminateBooking(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `terminateBooking$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  terminateBooking(params: TerminateBooking$Params, context?: HttpContext): Observable<void> {
    return this.terminateBooking$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createBooking()` */
  static readonly CreateBookingPath = '/api/user/bookings';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createBooking()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createBooking$Response(params: CreateBooking$Params, context?: HttpContext): Observable<StrictHttpResponse<BookingDto>> {
    return createBooking(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createBooking$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createBooking(params: CreateBooking$Params, context?: HttpContext): Observable<BookingDto> {
    return this.createBooking$Response(params, context).pipe(
      map((r: StrictHttpResponse<BookingDto>): BookingDto => r.body)
    );
  }

  /** Path part for operation `getBookingShares()` */
  static readonly GetBookingSharesPath = '/api/user/bookings/{id}/shares';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBookingShares()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBookingShares$Response(params: GetBookingShares$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ShareDto>>> {
    return getBookingShares(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBookingShares$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBookingShares(params: GetBookingShares$Params, context?: HttpContext): Observable<Array<ShareDto>> {
    return this.getBookingShares$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ShareDto>>): Array<ShareDto> => r.body)
    );
  }

  /** Path part for operation `createShare()` */
  static readonly CreateSharePath = '/api/user/bookings/{id}/shares';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createShare()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createShare$Response(params: CreateShare$Params, context?: HttpContext): Observable<StrictHttpResponse<ShareDto>> {
    return createShare(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createShare$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createShare(params: CreateShare$Params, context?: HttpContext): Observable<ShareDto> {
    return this.createShare$Response(params, context).pipe(
      map((r: StrictHttpResponse<ShareDto>): ShareDto => r.body)
    );
  }

  /** Path part for operation `openBox()` */
  static readonly OpenBoxPath = '/api/user/bookings/{bookingId}/open';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `openBox()` instead.
   *
   * This method doesn't expect any request body.
   */
  openBox$Response(params: OpenBox$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return openBox(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `openBox$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  openBox(params: OpenBox$Params, context?: HttpContext): Observable<void> {
    return this.openBox$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `closeBox()` */
  static readonly CloseBoxPath = '/api/user/bookings/{bookingId}/close';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `closeBox()` instead.
   *
   * This method doesn't expect any request body.
   */
  closeBox$Response(params: CloseBox$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return closeBox(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `closeBox$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  closeBox(params: CloseBox$Params, context?: HttpContext): Observable<void> {
    return this.closeBox$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getBookingLogs()` */
  static readonly GetBookingLogsPath = '/api/user/bookings/{id}/logs';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBookingLogs()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBookingLogs$Response(params: GetBookingLogs$Params, context?: HttpContext): Observable<StrictHttpResponse<PageDtoBookingLogBookingLogDto>> {
    return getBookingLogs(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBookingLogs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBookingLogs(params: GetBookingLogs$Params, context?: HttpContext): Observable<PageDtoBookingLogBookingLogDto> {
    return this.getBookingLogs$Response(params, context).pipe(
      map((r: StrictHttpResponse<PageDtoBookingLogBookingLogDto>): PageDtoBookingLogBookingLogDto => r.body)
    );
  }

  /** Path part for operation `getUserActiveBookings()` */
  static readonly GetUserActiveBookingsPath = '/api/user/bookings/{bookingId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserActiveBookings()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserActiveBookings$Response(params: GetUserActiveBookings$Params, context?: HttpContext): Observable<StrictHttpResponse<BookingDto>> {
    return getUserActiveBookings(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserActiveBookings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserActiveBookings(params: GetUserActiveBookings$Params, context?: HttpContext): Observable<BookingDto> {
    return this.getUserActiveBookings$Response(params, context).pipe(
      map((r: StrictHttpResponse<BookingDto>): BookingDto => r.body)
    );
  }

  /** Path part for operation `getBookingTowerInfo()` */
  static readonly GetBookingTowerInfoPath = '/api/user/bookings/{bookingId}/tower';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBookingTowerInfo()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBookingTowerInfo$Response(params: GetBookingTowerInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<TowerSimpleDto>> {
    return getBookingTowerInfo(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBookingTowerInfo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBookingTowerInfo(params: GetBookingTowerInfo$Params, context?: HttpContext): Observable<TowerSimpleDto> {
    return this.getBookingTowerInfo$Response(params, context).pipe(
      map((r: StrictHttpResponse<TowerSimpleDto>): TowerSimpleDto => r.body)
    );
  }

  /** Path part for operation `getBookingReadyToTerminate()` */
  static readonly GetBookingReadyToTerminatePath = '/api/user/bookings/{bookingId}/terminate/ready';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBookingReadyToTerminate()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBookingReadyToTerminate$Response(params: GetBookingReadyToTerminate$Params, context?: HttpContext): Observable<StrictHttpResponse<SimpleBooleanValue>> {
    return getBookingReadyToTerminate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBookingReadyToTerminate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBookingReadyToTerminate(params: GetBookingReadyToTerminate$Params, context?: HttpContext): Observable<SimpleBooleanValue> {
    return this.getBookingReadyToTerminate$Response(params, context).pipe(
      map((r: StrictHttpResponse<SimpleBooleanValue>): SimpleBooleanValue => r.body)
    );
  }

  /** Path part for operation `getBookingOpenCount()` */
  static readonly GetBookingOpenCountPath = '/api/user/bookings/{bookingId}/open/count';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBookingOpenCount()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBookingOpenCount$Response(params: GetBookingOpenCount$Params, context?: HttpContext): Observable<StrictHttpResponse<SimpleNumValue>> {
    return getBookingOpenCount(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBookingOpenCount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBookingOpenCount(params: GetBookingOpenCount$Params, context?: HttpContext): Observable<SimpleNumValue> {
    return this.getBookingOpenCount$Response(params, context).pipe(
      map((r: StrictHttpResponse<SimpleNumValue>): SimpleNumValue => r.body)
    );
  }

  /** Path part for operation `getAmount()` */
  static readonly GetAmountPath = '/api/user/bookings/{bookingId}/amount';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAmount()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAmount$Response(params: GetAmount$Params, context?: HttpContext): Observable<StrictHttpResponse<PaymentAmountDto>> {
    return getAmount(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAmount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAmount(params: GetAmount$Params, context?: HttpContext): Observable<PaymentAmountDto> {
    return this.getAmount$Response(params, context).pipe(
      map((r: StrictHttpResponse<PaymentAmountDto>): PaymentAmountDto => r.body)
    );
  }

  /** Path part for operation `getUserOpenTowers()` */
  static readonly GetUserOpenTowersPath = '/api/user/bookings/tower/open';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserOpenTowers()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserOpenTowers$Response(params?: GetUserOpenTowers$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BookingDto>>> {
    return getUserOpenTowers(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserOpenTowers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserOpenTowers(params?: GetUserOpenTowers$Params, context?: HttpContext): Observable<Array<BookingDto>> {
    return this.getUserOpenTowers$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BookingDto>>): Array<BookingDto> => r.body)
    );
  }

  /** Path part for operation `getUserTerminatedBookings()` */
  static readonly GetUserTerminatedBookingsPath = '/api/user/bookings/terminated';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserTerminatedBookings()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserTerminatedBookings$Response(params?: GetUserTerminatedBookings$Params, context?: HttpContext): Observable<StrictHttpResponse<PageDtoBookingBookingDto>> {
    return getUserTerminatedBookings(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserTerminatedBookings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserTerminatedBookings(params?: GetUserTerminatedBookings$Params, context?: HttpContext): Observable<PageDtoBookingBookingDto> {
    return this.getUserTerminatedBookings$Response(params, context).pipe(
      map((r: StrictHttpResponse<PageDtoBookingBookingDto>): PageDtoBookingBookingDto => r.body)
    );
  }

  /** Path part for operation `getUserActiveBookings1()` */
  static readonly GetUserActiveBookings1Path = '/api/user/bookings/active';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserActiveBookings1()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserActiveBookings1$Response(params?: GetUserActiveBookings1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BookingDto>>> {
    return getUserActiveBookings1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserActiveBookings1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserActiveBookings1(params?: GetUserActiveBookings1$Params, context?: HttpContext): Observable<Array<BookingDto>> {
    return this.getUserActiveBookings1$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BookingDto>>): Array<BookingDto> => r.body)
    );
  }

}
